import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { WidgetModule } from '../../../app/views/pages/widget/widget.module';
// import { HrmsModule} from '../../../app/views/pages/Hrms/hrms.module';
// Import the component you want to share
import { Tsk5020NewComponent } from '../../../app/views/pages/Hrms/TSK5020/New/tsk5020-new.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbAlertConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatProgressBarModule,
	MatDialogModule,
	MatNativeDateModule,
	MatRadioModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	DateAdapter,
	MAT_DATE_LOCALE,
	MAT_DATE_FORMATS
} from '@angular/material';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { WebcamModule } from 'ngx-webcam';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { RouterModule, Routes } from "@angular/router";


import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { MatTabsModule } from "@angular/material/tabs";
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDividerModule} from '@angular/material/divider';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {MatListModule} from '@angular/material/list';
import { TranslateModule } from "@ngx-translate/core";
import { PartialsModule } from "../../../app/views/partials/partials.module";
import { CoreModule } from "../../../app/core/core.module";
import { MatPaginatorModule } from '@angular/material/paginator';
import { MaterialPreviewModule } from '../../views/partials/content/general/material-preview/material-preview.module';
import { FileAttachmentComponent } from "../../../app/views/pages/Hrms/common/file-attachment/file-attachment.component";


// Material
import {
	MatButtonModule,
	MatCheckboxModule,
	MatFormFieldModule,
	MatInputModule,
} from "@angular/material";

import { Ba1110ChangeComponent } from '../../../../src/app/views/pages/Hrms/ba1110/Change/ba1110-change.component';

@NgModule({
  declarations: [
    Tsk5020NewComponent,   // declare once here
    FileAttachmentComponent,
    Ba1110ChangeComponent
  ],
  imports: [
                CommonModule,
                FormsModule,
                ReactiveFormsModule,
                MatButtonModule,
                RouterModule,
                MatInputModule,
                MatFormFieldModule,
                MatCheckboxModule,
                TranslateModule.forChild(),
                PartialsModule,
                NgbTooltipModule,
                MatTabsModule,
                MatMenuModule,
                MatIconModule,
                MatSidenavModule,
                CoreModule,
                MatCardModule,
                MatExpansionModule,
                MatDividerModule,
                MatListModule,
                MatPaginatorModule,
                MatTooltipModule,
            
                    SelectDropDownModule,
                    CommonModule,
                    PartialsModule,
                    NgbModule,
                    CoreModule,
                    MaterialPreviewModule,
                    // RouterModule.forChild(routes),
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    PerfectScrollbarModule,
                
                    MatButtonModule,
                    MatMenuModule,
                    MatSelectModule,
                    MatInputModule,
                    MatTableModule,
                    MatAutocompleteModule,
                    MatRadioModule,
                    MatIconModule,
                    MatNativeDateModule,
                    MatProgressBarModule,
                    MatDatepickerModule,
                    MatCardModule,
                    MatPaginatorModule,
                    MatSortModule,
                    MatCheckboxModule,
                    MatProgressSpinnerModule,
                    MatSnackBarModule,
                    MatExpansionModule,
                    MatTabsModule,
                    MatTooltipModule,
                    MatDialogModule,
                    CKEditorModule,
                    WebcamModule,
                    FroalaEditorModule,
                    FroalaViewModule,
                    MatButtonToggleModule,
                    DragDropModule
              
            //WidgetModule,
            // HrmsModule

  ],
  exports: [
    Tsk5020NewComponent,   // export so other modules can use it
    FileAttachmentComponent,
    Ba1110ChangeComponent
  ],
   entryComponents: [
    FileAttachmentComponent,    // <-- Dialog component
    Ba1110ChangeComponent
  ]
})
export class SharedTaskModule {}